var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 416,
    viewBox: "0 0 426 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56623_22125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.2148,
    y: 5.26025,
    width: 358.99,
    height: 346.334,
    rx: 15.5093,
    transform: "rotate(8.75606 62.2148 5.26025)",
    fill: "#DCE4EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.539,
    y: 5.70249,
    width: 358.214,
    height: 345.558,
    rx: 15.1216,
    transform: "rotate(8.75606 62.539 5.70249)",
    stroke: "#DADADB",
    strokeWidth: 0.775464
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 159.511,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 71.2347 109.903)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 159.511,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 63.887 163.836)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 159.511,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 55.5979 223.87)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 159.511,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 47.3089 283.903)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 89.1406,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 290.942 143.743)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 89.1406,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 283.594 197.676)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 89.1406,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 275.309 257.71)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 89.1406,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 267.02 317.744)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3199,
    y: 0.441552,
    width: 139.011,
    height: 13.1936,
    rx: 6.59678,
    transform: "matrix(0.988345 0.152228 -0.16329 0.986578 162.705 57.2324)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 58.2689,
    height: 55.406,
    rx: 27.703,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 92.7073 37.5733)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 180.656,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 69.2268 129.134)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 180.656,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 61.8831 183.067)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 180.656,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 53.594 243.1)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.31756,
    y: 0.441157,
    width: 180.656,
    height: 13.1948,
    rx: 6.59739,
    transform: "matrix(0.988345 0.152228 -0.169325 0.98556 45.3089 303.134)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 59.4088,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 288.493 162.904)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 59.4088,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 281.145 216.839)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 59.4088,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 272.86 276.872)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.320716,
    y: 0.441686,
    width: 59.4088,
    height: 13.1933,
    rx: 6.59663,
    transform: "matrix(0.988345 0.152228 -0.161187 0.986924 264.575 336.906)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3199,
    y: 0.441552,
    width: 109.812,
    height: 13.1936,
    rx: 6.59678,
    transform: "matrix(0.988345 0.152228 -0.16329 0.986578 159.045 81.5468)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.775464
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56623_22125",
    x: 0.90007,
    y: 0.97515,
    width: 424.715,
    height: 414.133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.30872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.3859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56623_22125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56623_22125",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLoading);
export default __webpack_public_path__ + "static/media/resume-loading.db3ca2404468fb4af5ea56d75cf338fe.svg";
export { ForwardRef as ReactComponent };